export default function (store, catalog) {
  store.commit('catalogTree/loading', true)
  catalog = catalog
    .map(node => filter(store, node))
    .filter(node => (node && node.children && node.children.length > 0))
  requestAnimationFrame(() => {
    store.commit('catalogTree/setCatalog', catalog)
    store.commit('catalogTree/loading', false)
  })
}

function filter (store, node) {
  if (node.header[0] === 'b' || node.header[0] === 'r') {
    node.children = node.children
      .map(child => filter(store, child))
      .filter(child => {
        return (child.data.children && child.data.children.length > 0) || (child.children && child.children.length > 0)
      })
  }
  if (node.header[0] === 'l') {
    const downloads = node.data.children.filter(child => child.giscube && child.giscube.downloadable)
    if (downloads.length > 0) {
      node.data.downloads = downloads
      downloads.forEach(download => store.dispatch('downloads/addDownload', download))
    }
    if (node.data.children.filter(child => !downloads.includes(child)).length === 0) {
      node.data.children = null
    }
  }
  return node
}
